import React, { Component } from 'react'
import './CorporateCheckout.css';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import CorporateLayoutWrapper from '../../../component/CorporateLayoutWrapper/'
import Footer from '../../../component/Footer/Footer';
import { CorporateCheckOutList, doCorporateCheckOutDetailsRes } from '../../../action/CorporateCheckOutDetailsAction'
import { corporateOrderPlace, doCorporatePlaceOrderRes } from '../../../action/CorporatePlaceOrderAction'
import { addCorporatePromoCode, doCorporatePromoCodeRes } from '../../../action/CorporatePromoCodeAction'
import loaderImg from '../../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Swal from 'sweetalert2';


class CorporateCheckout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAddressSubmited: false,
            isPromoCodeSubmited: false,
            firstName: '',
            lastName: '',
            company: '',
            streetAddress: '',
            City: '',
            postalCode: '',
            phoneNumber: '',
            addressBook: '',
            showAddressData: [],
            billingAddressData: [],
            cartDetailsData: [],
            cartSubTotal: '',
            totalBalance: '',
            codCharge: '',
            walletBalance: '',
            shippingRate: '',
            total: '',
            codShow: false,
            orderType: 'cod',
            isLoader: false,
            addressIDdata: props.location.state.addressId,
            addressBtn: props.location.state.addressBtn,
            csvData: [],
            customizeCod: true,
            promocode: '',
            applyBtn: true,
            couPonName: '',
            couPonType: '',
            couPonValue: '',
            discountAmount: '',
            couPonCode: '',
            loading: false,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }


    addressvalidate(values) {
        const errors = {};
        if (values.firstName && values.firstName.trim() === '') {
            errors.firstName = '*Please enter firstName';
        } else if (values.firstName === undefined) {
            errors.firstName = '*Please enter firstName';
        } else if (values.firstName === '') {
            errors.firstName = '*Please enter firstName';
        }

        if (values.lastName && values.lastName.trim() === '') {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === null) {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === undefined) {
            errors.lastName = '*Please enter lastName';
        } else if (values.lastName === '') {
            errors.lastName = '*Please enter lastName';
        }

        if (values.company && values.company.trim() === '') {
            errors.company = '*Please enter company';
        } else if (values.company === null) {
            errors.company = '*Please enter company';
        } else if (values.company === undefined) {
            errors.company = '*Please enter company';
        } else if (values.company === '') {
            errors.company = '*Please enter company';
        }

        if (values.streetAddress && values.streetAddress.trim() === '') {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === null) {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === undefined) {
            errors.streetAddress = '*Please enter streetAddress';
        } else if (values.streetAddress === '') {
            errors.streetAddress = '*Please enter streetAddress';
        }

        if (values.city && values.city.trim() === '') {
            errors.city = '*Please enter city';
        } else if (values.city === null) {
            errors.city = '*Please enter city';
        } else if (values.city === undefined) {
            errors.city = '*Please enter city';
        } else if (values.city === '') {
            errors.city = '*Please enter city';
        }

        if (values.postalCode && values.postalCode.trim() === '') {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === null) {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === undefined) {
            errors.postalCode = '*Please enter postalCode';
        } else if (values.postalCode === '') {
            errors.postalCode = '*Please enter postalCode';
        }


        if (values.phoneNumber && values.phoneNumber.trim() === '') {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === null) {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === undefined) {
            errors.phoneNumber = '*Please enter phoneNumber';
        } else if (values.phoneNumber === '') {
            errors.phoneNumber = '*Please enter phoneNumber';
        }

        //   if(values.addressBook && values.addressBook.trim() === ''){
        //     errors.addressBook = '*Please enter addressBook';
        //   }else if(values.addressBook === null){
        //     errors.addressBook = '*Please enter addressBook';
        //   }else if(values.addressBook === undefined){
        //     errors.addressBook = '*Please enter addressBook';
        //   }else if(values.addressBook === ''){
        //     errors.addressBook = '*Please enter addressBook';
        //   }     
        return errors;
    }

    AddressHandelSubmit = e => {
        e.preventDefault();
        this.setState({
            isAddressSubmited: true,
        }, () => { });
        this.addressvalidate(this.state);
        const errors = this.addressvalidate(this.state);
        if (Object.keys(errors).length === 0) {
            let requestData = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                company: this.state.company,
                streetAddress: this.state.streetAddress,
                city: this.state.city,
                postalCode: this.state.postalCode,
                phoneNumber: this.state.phoneNumber,
                addressBook: this.state.addressBook,

            }
            this.setState({
                isLoader: true
            })
            this.props.login_list(requestData)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.doCorporateCheckOutDetailsRes && nextProps.doCorporateCheckOutDetailsRes.user) {
            if (nextProps.doCorporateCheckOutDetailsRes.user && nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes) {
                if (nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes && nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.result === true) {
                    this.setState({
                        billingAddressData: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.billing_address,
                        cartDetailsData: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.cart_details,
                        cartSubTotal: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.cart_sub_total,
                        totalBalance: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.cart_sub_total,
                        codCharge: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.cod_charge,
                        walletBalance: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.wallet_balance,
                        shippingRate: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.shipping_rate,
                        total: nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.total,
                        isLoader: false,
                    }, () => {
                        let customeCheck = true;
                        for (let item of this.state.cartDetailsData) {
                            if ((item.product_id === "44" && item.product_type === "customize") || item.product_type === "simple") {

                            } else {
                                customeCheck = false;
                            }
                        }
                        this.setState({
                            customizeCod: customeCheck
                        })
                    })

                } else {
                    if (nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes && nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.result === false) {
                        if (nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.cart_details === null || nextProps.doCorporateCheckOutDetailsRes.user.CorporateCheckOutDetailsRes.cart_details.length === 0) {
                            this.props.history.push('/corporate-tab')
                        }
                    }
                    this.setState({
                        isLoader: false,
                    })
                }
            }
        }

        if (nextProps.doCorporatePlaceOrderRes && nextProps.doCorporatePlaceOrderRes.user) {
            if (nextProps.doCorporatePlaceOrderRes.user && nextProps.doCorporatePlaceOrderRes.user.CorporatePlaceOrderRes) {
                if (nextProps.doCorporatePlaceOrderRes.user.CorporatePlaceOrderRes && nextProps.doCorporatePlaceOrderRes.user.CorporatePlaceOrderRes.result === true) {
                    this.setState({
                        isLoader: false
                    })
                    // if (this.state.orderType === 'prepaid') {
                    if (nextProps.doCorporatePlaceOrderRes.user.CorporatePlaceOrderRes.url === "") {
                        this.props.history.push('/order-history')
                    } else {

                        window.location.href = nextProps.doCorporatePlaceOrderRes.user.CorporatePlaceOrderRes.url

                    }

                    // } if (this.state.orderType === 'cod') {
                    //     this.props.history.push('/order-history')
                    //     this.setState({
                    //         isLoader: false,
                    //     })
                    // }

                }
            }
        }

        if (nextProps.doCorporatePromoCodeRes && nextProps.doCorporatePromoCodeRes.user) {
            if (nextProps.doCorporatePromoCodeRes.user && nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes) {
                if (nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes && nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.result === true) {
                    this.setState({
                        promocode: '',
                        applyBtn: true,
                        couPonName: nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data && nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data.name,
                        couPonType: nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data && nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data.type,
                        couPonValue: nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data && nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data.value,
                        couPonCode: nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data && nextProps.doCorporatePromoCodeRes.user.CorporatePromoCodeRes.data.code,
                        isLoader: false,

                    }, () => {
                        if (this.state.couPonType === "percentage") {
                            let discountValue = this.state.cartSubTotal * this.state.couPonValue / 100
                            let totalValue = this.state.cartSubTotal - discountValue
                            this.setState({
                                discountAmount: discountValue,
                                cartSubTotal: totalValue
                            })
                        } else if (this.state.couPonType === "amount") {
                            let cartShipping = this.state.cartSubTotal + this.state.shippingRate
                            let discountValue = this.state.couPonValue > cartShipping ? 0.00 : (this.state.cartSubTotal - this.state.couPonValue)
                            this.setState({
                                discountAmount: this.state.couPonValue,
                                cartSubTotal: discountValue
                            })
                        }

                        // amount*persentage/100
                    })
                }
            }
        }

    }

    componentDidMount() {
        this.setState({ loading: true })
        if (this.props.location.state.csvData) {
            this.setState({
                csvData: this.props.location.state.csvData,
                loading: false
            })
        }


        if (this.state.addressBtn === "employeeAddress") {
            const checkOutdata = {
                add_id: '',
                userId: localStorage.getItem('userId'),
                address_type: "employee"
            }
            this.setState({
                isLoader: true,
            })
            this.props.CorporateCheckOutList(checkOutdata)
        } else {
            const checkOutdata = {
                add_id: this.state.addressIDdata,
                userId: localStorage.getItem('userId'),
                address_type: "office"
            }
            this.setState({
                isLoader: true,
            })
            this.props.CorporateCheckOutList(checkOutdata)
        }

    }


    orderPlaced = () => {
        if (this.state.addressBtn === "employeeAddress") {
            const orderQty = this.state.cartDetailsData.reduce((result, number) => result + parseInt(number.qty), 0)
            if (this.state.csvData.length === orderQty) {
                const data = {
                    add_id: '',
                    userId: localStorage.getItem('userId'),
                    address_type: "employee",
                    // order_type: '',
                    coupon_code: this.state.couPonCode,
                    address_data: JSON.stringify(this.state.csvData)
                }
                this.setState({
                    isLoader: true,
                })
                this.props.corporateOrderPlace(data)
            } else {
                Swal.fire({
                    title: "Kit or product quantity should be equal to number of employee address details!!!",
                    icon: 'warning',
                    width: 550,
                    confirmButtonText: 'Cancel',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    timer: 4000
                })
            }

        } else {
            const data = {
                add_id: this.state.addressIDdata,
                userId: localStorage.getItem('userId'),
                address_type: "office",
                // order_type: '',
                coupon_code: this.state.couPonCode,
                address_data: ''
            }
            this.setState({
                isLoader: true,
            })
            this.props.corporateOrderPlace(data)
        }
    }

    showCod = (e) => {
        if (e.target.value === 'cod') {
            this.setState({
                codShow: true,
                orderType: 'cod'
            })
        } else {
            this.setState({
                codShow: false,
                orderType: 'prepaid'
            })
        }

    }

    promoCodeValidate(values) {
        const errors = {};
        // if (values.promocode && values.promocode.trim() === '') {
        //     errors.promocode = '*Please enter promo code';
        // } else
        if (values.promocode === null) {
            errors.promocode = '*Please enter promo code';
        } else if (values.promocode === undefined) {
            errors.promocode = '*Please enter promo code';
        } else if (values.promocode.length > 11) {
            errors.promocode = '*Please enter valid promo code.';
        }
        // else if (values.promocode === '') {
        //     errors.promocode = '*Please enter promo code';
        // }
        return errors;
    }

    promoCodeChange = (e) => {
        if (e.target.value === '') {
            this.setState({
                applyBtn: true,
                promocode: e.target.value
            })
        } else {
            this.setState({
                applyBtn: false,
                promocode: e.target.value
            })
        }
    }

    PromoCodeSubmit = e => {
        e.preventDefault();
        this.setState({
            isPromoCodeSubmited: true
        })
        this.promoCodeValidate(this.state);
        const errors = this.promoCodeValidate(this.state);
        if (Object.keys(errors).length === 0) {
            let requestData = {
                promoCode: this.state.promocode
            }
            this.setState({
                isLoader: true
            })
            this.props.addCorporatePromoCode(requestData)
        }

    }

    couponCodeDelete = () => {
        let totalBalanceCard = this.state.totalBalance + this.state.shippingRate - this.state.walletBalance
        this.setState({
            couPonName: '',
            couPonType: '',
            couPonValue: '',
            couPonCode: '',
            discountAmount: '',
            cartSubTotal: totalBalanceCard
        })
    }

    render() {

        const spinner = <span><img src={loaderImg} alt="" /></span>;
        const errors = this.promoCodeValidate(this.state);
        const { isPromoCodeSubmited } = this.state;
        return (
            <React.Fragment>
                <Loader show={this.state.isLoader} message={spinner}>
                    <CorporateLayoutWrapper />
                    <main className="main">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav mb-2">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="/">Home</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Checkout</li>
                                </ol>
                            </div>
                            {/* End .container  */}
                        </nav>
                        <div className="container">
                            <ul className="checkout-progress-bar">
                                <li>
                                    <span>Shipping</span>
                                </li>
                                <li className="active">
                                    <span>Review &amp; Payments</span>
                                </li>
                            </ul>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="checkout-info-box">
                                        <h3 className="step-title">Your Order:
                                            {/* <a href="/checkout" title="Edit" className="step-title-edit">
                                                <span className="sr-only">Edit</span>
                                                <i className="icon-pencil"></i>
                                            </a> */}
                                        </h3>
                                        {
                                            this.state.couPonCode ?

                                                <div>
                                                    <table className="table">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <div>
                                                                        <span className="product-name">Promo Code</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span className="product-price">{this.state.couPonCode}</span>
                                                                    <i className='fa fa-trash-alt del-add' onClick={() => this.couponCodeDelete()}></i>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                :
                                                <div>
                                                    <form onSubmit={this.PromoCodeSubmit} className="promoCodeForm">
                                                        <div className="row">
                                                            <div className="col-md-8">
                                                                <input type="text" name="promocode" className="form-control" value={this.state.promocode || ""} onChange={(e) => this.promoCodeChange(e)} placeholder="Enter promo code" autoComplete="off" />
                                                                {errors && isPromoCodeSubmited && <span className="error-message msg">{errors.promocode}</span>}
                                                            </div>
                                                            <div className="col-md-4">
                                                                <button className="btn btn-primary float-right show-color btn-line-hight" disabled={this.state.applyBtn} type="submit">
                                                                    Apply
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </form>
                                                </div>

                                        }

                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">PRODUCT</th>
                                                    <th scope="col">SUBTOTAL</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.cartDetailsData && this.state.cartDetailsData.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div>
                                                                <span className="product-name">{item.name}x &nbsp; {item.qty}</span>
                                                                {(item.color !== '' && item.size !== '' && item.sleeve !== '') &&
                                                                    <p className="fnt-size mb-0">Color : {item.color}, Size: {item.size}, sleeve : {item.sleeve} </p>
                                                                }</div>
                                                        </td>
                                                        <td><span className="product-price"> <i className="fa fa-rupee-sign"></i>{parseFloat(Number(item.sub_total)).toFixed(2)}</span></td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th scope="col">Subtotal</th>
                                                    <td>
                                                        <span className="product-price"> <i className="fa fa-rupee-sign"></i>
                                                            {/* {this.state.promocode.length === 0 ? parseFloat(Number(this.state.cartSubTotal)).toFixed(2) : parseFloat(Number(this.state.totalBalance)).toFixed(2)} */}
                                                            {parseFloat(Number(this.state.totalBalance)).toFixed(2)}
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <th scope="col">Shipping</th>
                                                    <td><span className="product-price"> <i className="fa fa-rupee-sign"></i> {parseFloat(Number(this.state.shippingRate)).toFixed(2)}</span></td>
                                                </tr>
                                                {/* {this.state.codShow && */}
                                                <tr>
                                                    <th scope="col">COD Charges</th>
                                                    <td><span className="product-price"> <i className="fa fa-rupee-sign"></i>{parseFloat(Number(this.state.codCharge)).toFixed(2)}</span></td>
                                                </tr>
                                                {/* } */}
                                                {
                                                    this.state.couPonType !== "cashback" && this.state.discountAmount &&
                                                    <tr>
                                                        <th scope="col">Discount</th>
                                                        <td>
                                                            <span className="product-price">- <i className="fa fa-rupee-sign"></i>
                                                                {parseFloat(Number(this.state.discountAmount)).toFixed(2)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                }

                                                <tr>
                                                    <th scope="col">Wallet Balance</th>
                                                    <td><span className="product-price">{parseFloat(Number(this.state.walletBalance)) === 0 ? '' : '-'} <i className="fa fa-rupee-sign"></i> {parseFloat(Number(this.state.walletBalance)).toFixed(2)}</span></td>
                                                </tr>


                                                <tr>
                                                    <th scope="col">Total</th>
                                                    {
                                                        this.state.orderType === 'cod' ?
                                                            <td>
                                                                <span className="product-price">
                                                                    <i className="fa fa-rupee-sign"></i>
                                                                    {parseFloat(Number(this.state.cartSubTotal) + Number(this.state.codCharge) + Number(this.state.shippingRate) - Number(this.state.walletBalance)).toFixed(2)}
                                                                </span>
                                                            </td>
                                                            :
                                                            <td>
                                                                <span className="product-price">
                                                                    <i className="fa fa-rupee-sign"></i>
                                                                    {parseFloat(Number(this.state.cartSubTotal)) === 0 ? parseFloat(Number(this.state.cartSubTotal)).toFixed(2) : parseFloat(Number(this.state.cartSubTotal) + Number(this.state.shippingRate) - Number(this.state.walletBalance)).toFixed(2)}
                                                                </span>
                                                            </td>
                                                    }
                                                </tr>
                                            </tfoot>
                                        </table>
                                        <ul>
                                            <li>
                                                {/* <input type="radio" className="input-radio" name="payment_method" onClick={(e) => this.showCod(e)} value="prepaid" checked={this.state.orderType === 'prepaid'} readOnly />
                                                <label className="pl-5">Credit/Debit Card/NetBanking/Wallet/Upi</label> <br /> */}
                                                {/* {
                                                    this.state.customizeCod ? */}
                                                <div>
                                                    <input type="radio" onClick={(e) => this.showCod(e)} className="input-radio" name="payment_method" value="cod" checked={this.state.orderType === 'cod'} readOnly />
                                                    <label className="pl-5" >Cash on delivery</label>
                                                </div>
                                                {/* : ''
                                                } */}

                                            </li>
                                            <li>

                                            </li>
                                        </ul>

                                        <div className="clearfix">
                                            <div className="btn btn-primary float-right show-color" onClick={() => this.orderPlaced()}>Place Order</div>
                                        </div>

                                    </div>
                                    {/* End .checkout-info-box */}


                                </div>
                                {/* End .col-lg-4 */}

                                <div className="col-lg-8 order-lg-first">
                                    <div className="checkout-payment">
                                        <h2 className="step-title">BILLING DETAILS:</h2>
                                        {/* <h4>Check / Money order</h4>  */}

                                        {
                                            this.state.addressBtn === "employeeAddress" ?
                                                <div className='datatable-width'>
                                                    <DataTable value={this.state.csvData} scrollable loading={this.state.loading} >
                                                        <Column field="Name" header="Name" style={{ minWidth: '200px' }}></Column>
                                                        <Column field="Email" header="Email" style={{ minWidth: '200px' }}></Column>
                                                        <Column field="Company Name" header="Company Name" style={{ minWidth: '100px' }}></Column>
                                                        <Column field="City" header="City" style={{ minWidth: '100px' }}></Column>
                                                        <Column field="Address" header="Address" style={{ minWidth: '100px' }}></Column>
                                                        <Column field="Pincode" header="Pin Code" style={{ minWidth: '200px' }}></Column>
                                                        <Column field="State" header="State" style={{ minWidth: '200px' }}></Column>
                                                    </DataTable>
                                                </div>
                                                :


                                                <div id="new-checkout-address" className="show">
                                                    {this.state.billingAddressData && this.state.billingAddressData.map((item, i) => (
                                                        <form key={i}>
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="form-group required-field col-md-6">
                                                                        <label>First Name </label>
                                                                        <input type="text" className="form-control" name="firstName" value={item.first_name} readOnly />

                                                                    </div>
                                                                    {/* End .form-group */}

                                                                    <div className="form-group required-field col-md-6">
                                                                        <label>Last Name </label>
                                                                        <input type="text" className="form-control" name="lastName" value={item.last_name} readOnly />

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* End .form-group */}
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="form-group col-md-6">
                                                                        <label>Company </label>
                                                                        <input type="text" className="form-control" name="company" value={item.company} readOnly />
                                                                    </div>

                                                                    <div className="form-group required-field col-md-6">
                                                                        <label>Phone Number </label>
                                                                        <div className="form-control-tooltip">
                                                                            <input type="tel" className="form-control" name="phoneNumber" value={item.phone_number} readOnly />
                                                                        </div>
                                                                        {/* End .form-control-tooltip */}
                                                                    </div>
                                                                </div>
                                                                {/* End .form-group */}
                                                            </div>

                                                            {/* End .form-group */}
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="form-group required-field col-md-6">
                                                                        <label>Street Address </label>
                                                                        <input type="text" className="form-control" name="streetAddress" value={item.street_address} readOnly />

                                                                        {/* <input type="text" className="form-control" required/> */}
                                                                    </div>
                                                                    {/* End .form-group */}

                                                                    <div className="form-group required-field col-md-6">
                                                                        <label>City  </label>
                                                                        <input type="text" className="form-control" name="City" value={item.city} readOnly />

                                                                    </div>
                                                                    {/* End .form-group */}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="form-group col-md-6">
                                                                        <label>State/Province</label>
                                                                        <input type="text" className="form-control" name="state" value={item.state} readOnly />
                                                                        {/* End .select-custom */}
                                                                    </div>
                                                                    {/* End .form-group */}

                                                                    <div className="form-group required-field col-md-6">
                                                                        <label>Zip/Postal Code </label>
                                                                        <input type="text" className="form-control" name="postalCode" value={item.zip_code} readOnly />
                                                                    </div>
                                                                    {/* End .form-group */}
                                                                </div>
                                                            </div>
                                                        </form>
                                                    ))}

                                                </div>
                                        }
                                        {/* End #new-checkout-address */}


                                        {/* End .clearfix */}
                                    </div>
                                    {/* End .checkout-payment */}

                                    <div className="checkout-discount">
                                        {/* <h4>
                                            <a data-toggle="collapse" href="checkout-review.html#checkout-discount-section" className="collapsed" role="button" aria-expanded="false" aria-controls="checkout-discount-section">Apply Discount Code</a>
                                        </h4>

                                        <div className="collapse" id="checkout-discount-section">
                                            <form action="/">
                                                <input type="text" className="form-control form-control-sm" placeholder="Enter discount code"  required/>
                                                <button className="btn btn-sm btn-outline-secondary" type="submit">
                                                    Apply Discount
                                                </button>
                                            </form>
                                        </div> */}
                                        {/* End .collapse */}
                                    </div>
                                    {/* End .checkout-discount */}
                                </div>
                                {/* End .col-lg-8 */}
                            </div>
                            {/* End .row */}
                        </div>
                        {/* End .container */}

                        <div className="mb-6"></div>
                        {/* margin */}
                    </main>
                    {/* End .main */}
                </Loader>
                <Footer />
            </React.Fragment>
        )
    }
}

CorporateCheckout.propTypes = {
    doCorporateCheckOutDetailsRes: PropTypes.any,
    doCorporatePlaceOrderRes: PropTypes.any,
    doCorporatePromoCodeRes: PropTypes.any
};

const mapStateToProps = createStructuredSelector({
    doCorporateCheckOutDetailsRes: doCorporateCheckOutDetailsRes,
    doCorporatePlaceOrderRes: doCorporatePlaceOrderRes,
    doCorporatePromoCodeRes: doCorporatePromoCodeRes
});

function mapDispatchToProps(dispatch) {
    return {
        CorporateCheckOutList: (data) => dispatch(CorporateCheckOutList(data)),
        corporateOrderPlace: (data) => dispatch(corporateOrderPlace(data)),
        addCorporatePromoCode: (data) => dispatch(addCorporatePromoCode(data))
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(CorporateCheckout)